
import StepRuslt from './module/MatchCarResult';
/* eslint-disable no-alert */
const { $ } = window;

export default class MatchCarExtent {
  constructor() {
    this.questionList = [];
    this.isConstructor = true;
    this.init();
    this.checkitem = [];
    this.p1 = [];
    this.p2 = [];
    this.p3 = [];
    this.p4 = [];
    this.p5 = [];
    this.per = [];
  }

  init() {
    const self = this;
    // 看速配結果按鈕事件
    $('[data-match-confirm]').on('click', (event) => {
      event.preventDefault();
      const motivationItems = $('input[name="motivation"]:checked');
      const preferredItems = $('input[name="preferred"]:checked');
      const colorToneItems = $('input[name="colorTone"]:checked');
      let msgFlag = false;
      let matchCheckMsg = '';
      // 檢查是否有勾選
      if (motivationItems.length === 0) {
        msgFlag = true;
        matchCheckMsg = '請問你為什麼想買車呢？\n';
      }
      if (preferredItems.length === 0) {
        msgFlag = true;
        matchCheckMsg += '請問你對理想中的愛車偏好是？\n';
      }
      if (colorToneItems.length === 0) {
        msgFlag = true;
        matchCheckMsg += '請問你喜歡哪種色調的車呢？\n';
      }

      if (msgFlag) {
        window.alert(matchCheckMsg);
      } else {
        // 查詢速配結果
        self.onSubmitClick();
      }
    });
  }

  // 取得勾選資料
  getOptionValues(option) {
    const checktmp = [];
    option.each((index, elem) => {
      if ($(elem).is(':checked')) {
        checktmp.push($(elem).val());
      }
    });
    this.checkitem = checktmp;
    return this.checkitem;
  }

  // 查詢速配結果
  onSubmitClick() {
    const optionMotivation = $('input[name=motivation]');
    const optionSpecies = $('input[name=species]');
    const optionPreferred = $('input[name=preferred]');
    const optionColorTone = $('input[name=colorTone]');
    const Motivation = this.getOptionValues(optionMotivation);
    const species = this.getOptionValues(optionSpecies);
    const preferred = this.getOptionValues(optionPreferred);
    const colorTone = this.getOptionValues(optionColorTone);
    // console.log(`Motivation${Motivation}`);
    // 範圍區間
    const sliderValuelower = $('[data-match-budgetbar]').find('.noUi-handle-lower').attr('aria-valuenow');
    const sliderValueupper = $('[data-match-budgetbar]').find('.noUi-handle-upper').attr('aria-valuenow');
    const min = Math.round(parseFloat(sliderValuelower));
    const max = Math.round(parseFloat(sliderValueupper));
    this.p1 = [];
    this.p1.push(min);
    this.p1.push(max);
    // 人數
    this.per = $('#member-counter-input').val();
    this.p2 = Motivation;
    this.p3 = species;
    this.p4 = preferred;
    this.p5 = colorTone;
    // console.log(this.p1);
    // console.log(this.p2);
    // console.log(this.p3);
    // console.log(this.p4);
    // console.log(this.p5);
    this.sendMatchData();
  }

  // 取得速配資料
  sendMatchData() {
    // 速配結果api
    $.ajax(`api/match.ashx?t=${Date.now()}`, {
      dataType: 'json',
      type: 'POST',
      data: {
        P1: this.p1.join(','),
        P2: this.p2.join(','),
        P3: this.p3.join(','),
        P4: this.p4.join(','),
        P5: this.p5.join(','),
        PER: this.per,
      },
      success: (res) => {
        if (res.RS !== 'OK') alert(res.RS);
        else {
          this.questionList = res.DATA;
          // console.log(this.questionList);
          if (this.questionList.length > 0) {
            $('[data-match-question]').hide();
            $('[data-match-result]').show();
            // 載入速配結果畫面
            this.onLoadRuslt();
          }
        }
      },
      error: () => {
        alert('伺服器忙碌中，請稍候重試。謝謝！');
      },
    });
  }

  onLoadRuslt() {
    // 載入速配結果畫面
    this.stepSelect = new StepRuslt(this.questionList);
    this.stepSelect.render();
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }
}
